/**
 * Tracks the user's last visited route in localStorage so the next cold
 * boot can warm up that route's lazy chunk via <link rel="modulepreload">.
 *
 * Storing only the route path (e.g. "/growth") — never chunk URLs, which
 * change hash on every deploy. The router still guards access, so a stale
 * preloaded chunk is at worst a wasted prefetch, never a security issue.
 */

const KEY = 'invisa:last-route';

const SKIP_PREFIXES = ['/auth', '/admin', '/pin-', '/lemonade-return'];

export const rememberRoute = (path: string) => {
  try {
    if (!path || path === '/') return;
    if (SKIP_PREFIXES.some((p) => path.startsWith(p))) return;
    localStorage.setItem(KEY, path);
  } catch {
    /* noop */
  }
};

export const getLastRoute = (): string | null => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const clearLastRoute = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
};
